import * as yup from 'yup';
import _ from 'lodash';
import { CommonConf } from './common/Common.conf';
import { CaptainConf } from './common/Captain.conf';
import { RotateCaptainConf } from './common/RotateCaptain.conf';

export const CreateConf = {
	Crew: {
		Captain: {
			schema: yup.object({
				...CommonConf.schema,
				...CaptainConf.schema
			}),
			defaultValues: {
				...CommonConf.defaultValues,
				...CaptainConf.defaultValues
			},
			fields: _.concat(CommonConf.fields.slice(0, 7), CaptainConf.fields, CommonConf.fields.slice(7)),
		},
		"Rotate Captain": {
			schema: yup.object({
				...CommonConf.schema,
				...RotateCaptainConf.schema
			}),
			defaultValues: {
				...CommonConf.defaultValues,
				...RotateCaptainConf.defaultValues
			},
			fields: _.concat(CommonConf.fields.slice(0, 7), RotateCaptainConf.fields, CommonConf.fields.slice(7)),
		},
		Common: {
			schema: yup.object({
				...CommonConf.schema
			}),
			defaultValues: {
				...CommonConf.defaultValues
			},
			fields: CommonConf.fields,
		}
	},

};
